export const calculateDistanceBetweenPositions = (position, comparingPosition) => {
    const xDifference = position.x - comparingPosition.x;
    const yDifference = position.y - comparingPosition.y;
    return Math.sqrt(Math.pow(xDifference, 2) + Math.pow(yDifference, 2));
};
export const calculatePartialDistance = (position, target) => {
    const dx = typeof target.X === 'number' && typeof position.X === 'number' ? target.X - position.X : 0;
    const dy = typeof target.Y === 'number' && typeof position.Y === 'number' ? target.Y - position.Y : 0;
    const dz = typeof target.Z === 'number' && typeof position.Z === 'number' ? target.Z - position.Z : 0;
    return Math.sqrt(Math.pow(dx, 2) + Math.pow(dy, 2) + Math.pow(dz, 2));
};
//# sourceMappingURL=calculateDistance.js.map